import {useEffect, useState} from "react";
import proxy from "../../utils/Proxy";
import {getDateString, limitInputNumber, moveModal} from "../../utils/Utils";
import "../../css/modal/UserLessonListModal.css"
import TeacherConstant from "../../utils/constants/TeacherConstant";
import Pagination from "../footer/Pagination";
import LessonModifyHistoryModal from "./LessonModifyHistoryModal";

let UserLessonListModal = (props) => {
    // props로 userid, opened받아야함
    let [lessonList, setLessonList] = useState([]);
    let [page, setPage] = useState(1);
    let [listLength, setListLength] = useState(0);
    let [childModalOpened, setChildModalOpened] = useState(false);

    useEffect(() => {
        proxy.get("/adminapi/lessons/users/" + props.userid + "/?page=" + page + "&count=" + 4)
            .then(res => {
                let data = res.data.data;
                setLessonList(data);
                setListLength(res.data.totalLength)
            }).catch(err => {
            window.alert(err.response.data.message)
        })
    }, [page, props.userid])

    let onClickHistory = (_) => {
        setChildModalOpened(true);
    }

    let onClickSubmit = (_) => {
        Promise.all([requestLessonNote(), requestLessonComplete()]).then(() => {
            window.alert("변경 사항이 저장되었습니다.");
            props.setOpened(false)
            if (typeof props.setNeedUpdate !== "undefined" && props.setNeedUpdate !== null)
                props.setNeedUpdate(true)
        })
    }

    let requestLessonComplete = async () => {
        let isDoneCheckboxes = document.querySelectorAll('input[class^="lesson-isdone"]')

        for (let checkbox of isDoneCheckboxes) {
            let lessonid = parseInt(checkbox.id.split(":")[1])

            let defaultChecked = checkbox.defaultChecked;
            let checked = checkbox.checked;
            if (checked !== defaultChecked) {
                await proxy.put("/adminapi/lessons/" + lessonid, {done: checked})
            }
        }
    }

    let requestLessonNote = async () => {
        let noteElements = document.querySelectorAll('textarea[class^="lesson-note"]')

        for (let noteElement of noteElements) {
            let lessonid = parseInt(noteElement.id.split(":")[1]);

            let defaultValue = noteElement.defaultValue;
            let changedValue = noteElement.value;

            if (defaultValue === changedValue || ((defaultValue === "" || defaultValue === null) && changedValue === ""))
                continue;

            await proxy.put("/adminapi/lessons/note/" + lessonid, {note: changedValue})
        }
    }

    let getLessonList = () => {
        let ret = []
        for (let lessonIndex in lessonList) {
            let lesson = lessonList[lessonIndex]

            let teacher = props.data.teachers[lesson.teacherid];
            let teacherName = TeacherConstant.major_symbol[teacher.major] + teacher.name;

            let lessonNoteId = "lesson-note:" + lesson.lessonid;
            let isDoneId = "lesson-isdone:" + lesson.lessonid
            ret.push(<div className="lesson-row-container" key={"lesson" + lesson.lessonid}>
                <div className="lesson-element-cell lesson-column-number">
                    <p>{lesson.lessonid}</p>
                </div>
                <div className="lesson-element-cell lesson-column-date">
                    <p>{getDateString(new Date(lesson.due))} {lesson.hour}시</p>
                </div>
                <div className="lesson-element-cell lesson-column-teacher">
                    <p>{teacherName}</p>
                </div>
                <div className="lesson-element-cell lesson-column-isdone">
                    <input className="lesson-isdone" type="checkbox" defaultChecked={lesson.is_done} id={isDoneId}/>
                </div>
                <div className="lesson-element-cell lesson-column-lessonnote">
                    <div className="lesson-note-container">
                        <textarea className="lesson-note" defaultValue={lesson.note}
                                  placeholder="공백포함 270자" id={lessonNoteId} onChange={e=>limitInputNumber(e, 270)}/>
                    </div>
                </div>
            </div>)
        }
        return ret;
    }
    return (<div className="modal-container child-modal-container">
        <div className="modal" id="user-lesson-list-modal">
            <div className="modal-content-container">
                <div className="modal-header" onMouseDown={e => moveModal(e, "user-lesson-list-modal")}>
                    <p className="modal-title">
                        {props.username} 님의 레슨 목록
                    </p>
                    <div className="modal-close-button" onClick={() => {
                        props.setOpened(false)
                    }}></div>
                </div>
                <div className="modal-content lesson-list-content">
                    <div className="lesson-list-table-container">
                        <div className="lesson-list-table-header">
                            <div className="lesson-element-cell lesson-column-number">
                                <p className="lesson-column-header-text">번호</p>
                            </div>

                            <div className="lesson-element-cell lesson-column-date">
                                <p className="lesson-column-header-text">날짜</p>
                            </div>

                            <div className="lesson-element-cell lesson-column-teacher">
                                <p className="lesson-column-header-text">선생님</p>
                            </div>

                            <div className="lesson-element-cell lesson-column-isdone">
                                <p className="lesson-column-header-text">완료 여부</p>
                            </div>

                            <div className="lesson-element-cell lesson-column-lessonnote">
                                <p className="lesson-column-header-text">레슨 노트</p>
                            </div>
                        </div>
                        <div className="lesson-list-table">
                            {getLessonList()}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <Pagination page={page} setPage={setPage.bind(this)}
                                listLength={listLength} countPerPage={4}/>
                    <div className="modal-footer-button-container">
                        <div className="modal-button" onClick={onClickHistory.bind(this)}>
                            <p>레슨 예약/취소 내역</p>
                        </div>
                        {childModalOpened ? (<LessonModifyHistoryModal
                            setOpened={setChildModalOpened.bind(this)}
                            opened={childModalOpened}
                            data={props.data}
                            name={props.username} userid={props.userid}
                        />) : null}
                        <div className="modal-button" onClick={onClickSubmit.bind(this)}>
                            <p>변경사항 저장</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}
export default UserLessonListModal